"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupSearchIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PopupSearchIcon = () => {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsxs)("g", { fill: "#383838", fillRule: "evenodd", children: [(0, jsx_runtime_1.jsx)("path", { d: "M10 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm0 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10z" }), (0, jsx_runtime_1.jsx)("path", { d: "m20.08 17.792-.357-.288-3.67-3.074a1.348 1.348 0 0 0-1.823.091c-.48.5-.441 1.268.086 1.716l4.1 3.45a1.302 1.302 0 0 0 1.815-.137 1.222 1.222 0 0 0-.15-1.758z" })] }) }));
};
exports.PopupSearchIcon = PopupSearchIcon;
